import { useState } from 'react'

const useElement = () => useState(null)

export default useElement
